import { useRef } from "react";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import { styles } from "./styles";

export function DrawerPushContent({
  children,
  setContentMaxHeight,
  setContentTopOffset,
  isOpen
}: {
  children: React.ReactNode | React.ReactNode[];
  setContentMaxHeight?: (value: string) => void;
  setContentTopOffset?: (value: string) => void;
  isOpen?: boolean;
}) {
  const pushContentInitialOffset = useRef<number>(0);
  const pushContentRef = useRef<HTMLDivElement>(null);

  const setPushedContentTopRef = useIntersectionObserver({
    threshold: 0,
    onIntersection: ([entry]) => {
      const vals = [
        "var(--drawer-header-height)",
        "var(--drawer-footer-height)"
      ];
      if (entry.isIntersecting) {
        vals.push(`${Math.max(0, pushContentInitialOffset.current)}px`);
      }
      setContentMaxHeight?.(`calc(100vh - (${vals.join(" + ")}))`);
    }
  });

  const setPushedContentBottomRef = useIntersectionObserver({
    threshold: 0,
    onIntersection: ([entry]) => {
      setContentTopOffset?.(
        entry.isIntersecting
          ? "0px"
          : "calc(var(--drawer-header-height) + var(--drawer-top-offset))"
      );
    }
  });
  function setPushedContentRef(
    which: "top" | "bottom",
    element: HTMLDivElement | null
  ) {
    if (which === "top") {
      setPushedContentTopRef(element);
      if (element) {
        pushContentInitialOffset.current = element.getBoundingClientRect().top;
      }
    } else {
      setPushedContentBottomRef(element);
    }
  }
  if (!children) {
    return null;
  }
  return (
    <div
      className="kit-drawer-push-content"
      ref={pushContentRef}
      css={[
        styles.content.pushedContent,
        isOpen && styles.content.pushContentOpened
      ]}
    >
      <div ref={current => setPushedContentRef("top", current)} />
      {children}
      <div ref={current => setPushedContentRef("bottom", current)} />
    </div>
  );
}
